import React from 'react'

import btn_img from './images/yellow_button1.png'
import btn_img_ru from './images/yellow_button2.png'

import './css/index.css'

class DeepLinkButton extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleClick = this.handleClick.bind(this);

    this.state = {
      
    };
  }

  getParams(search_string) {    
      var parse = function(params, pairs)
      {
          var pair = pairs[0];
          var parts = pair.split('=');
          var key = decodeURIComponent(parts[0]);
          var value = decodeURIComponent(parts.slice(1).join('='));

          // Handle multiple parameters of the same name
          if (typeof params[key] === "undefined") {
              params[key] = value;
          } else {
              params[key] = [].concat(params[key], value);
          }

          return pairs.length == 1 ? params : parse(params, pairs.slice(1))
      }

      // Get rid of leading ?
      return search_string.length == 0 ? {} : parse({}, search_string.substr(1).split('&'));
      
  }

  openDeepLink() {
      var params = this.getParams(window.location.search);

      window.location.href = "tanksalot://AcceptClanRequest?id=" + params["id"];
  }

  handleClick() {
    this.props.showHintCallback();
    //console.log("button pressed! ");
    this.openDeepLink();
  }

  render() {
    return (
      <div>
        <button title={this.props.title} className="footerButton3" onClick={this.handleClick}>
          <img src={this.props.ru == "true" ? btn_img_ru : btn_img}/>
        </button>
      </div>
    );
  }
}
export default DeepLinkButton


// WEBPACK FOOTER //
// ./src/DeepLinkButton.js